/*!
=========================================================
* 敷金管理　入金履歴登録
=========================================================
*/
import React from "react";

import {
  Button,
  Card,  CardHeader,  CardTitle,
  Table,  Row,  Col, Container,
  Modal, ModalBody, ModalFooter
} from "reactstrap";
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import InputText from '../FormParts/InputText'
import InputNumber from '../FormParts/InputNumber'
import InputSelect from '../FormParts/InputSelect'
import Request from '../../common/Request';
import Format from '../../common/Format';
import FormatCode from '../../common/FormatCode';
import CustomTd from '../ViewParts/CustomTd';
import _ from 'underscore';
import {
  cst_security_deposit_collect_type
} from '../../variables/codes_map';
import Definition from '../../common/Definition'
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import WithRole from '../FormParts/ButtonWithRole';
import InputDatetime from "../FormParts/InputDatetime";
import InputCheckBox from "../FormParts/InputCheckBox";
import { GetMessage, getErrorCodes } from '../../variables/message';

class Regist extends React.Component {

  constructor(props){
    super(props);
    this.state ={
        regist_modal: false,
        sub_regist_modal: false,
        error_modal: false,
        view: false,
        error:true,
        securityDepositDetails : [],
        data:{
          values : {
            security_deposit_flag : 0
          },
          errors:{},
          requiredData:{},
        },
        dialogData : {
          values:{},
          errors:{},
          requiredData:{
            security_deposit_collect_date:[GetMessage(2024)],
            security_deposit_collect_amt:[GetMessage(2024)],
            security_deposit_collect_type:[GetMessage(2024)],
          }
        },
        request_data:{},
        estimate:{},
        user_list : [],
    };

    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.toggleSubRegistModal = this.toggleSubRegistModal.bind(this);
    this.summation_select_popup = React.createRef();
    this.validateCallback = this.validateCallback.bind(this)
    this.validateDialogCallback = this.validateDialogCallback.bind(this)
    this.regist = this.regist.bind(this)
    this.security_deposit_details = this.security_deposit_details.bind(this)
    this.selectedSecurityDeposit = this.selectedSecurityDeposit.bind(this);
    this.securityDepositEdit = this.securityDepositEdit.bind(this)
    this.securityDepositRemove = this.securityDepositRemove.bind(this);
    this.calcTotalAmount = this.calcTotalAmount.bind(this);
  } 

  // 初期ロード用
  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      console.log("user res ", res)
      this.setState({
        user_list : res.Data
      });
    })

    // 敷金
    Request.get(`/api/securitydeposit`, { ulid : this.props.match.params.ulid, security_deposit_status : [0,1,2] } , res => {

      if(res.Data.length==0 || this.props.data_view_flag==2 && (res.Data[0]&&res.Data[0].user_branch_id != GsuiteAuth.get('user_branch_id'))){
        this.props.pageChangeAlert.current.inactivate();
        this.props.history.push('/forbidden')
        return;
      } 

      this.setState({
        data : { 
          ...this.state.data,
          values : {
            ...res.Data[0],
            security_deposit_flag : res.Data[0].security_deposit_status == 2 ? 1 : 0,
            ___CAL_security_deposit_amt : res.Data[0].quote_cost_security_deposit_total_amt + res.Data[0].add_cost_security_deposit_amt
          }
        }
      })

      // 敷金入金履歴
      Request.get(`/api/securitydeposit/detail`, { security_deposit_id : res.Data[0].id } , res => {
        this.setState({
          securityDepositDetails : res.Data
        });
      })
    })
  }

  validate(errors){
    let message = getErrorCodes(errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    const required_collect_finish_date = 
    (newData.values.security_deposit_flag == 1 && !newData.values.security_deposit_collect_finish_date) 
    ? { security_deposit_collect_finish_date : [GetMessage(2024)] } 
    : { security_deposit_collect_finish_date : undefined }

    this.setState({
      data:{
        ...this.state.data,
        ...newData,
        values:{
          ...newData.values,
        },
        errors:{
          ...newData.errors,
          ...required_collect_finish_date
        }
      }
    }, ()=>callback())
  }

  validateDialogCallback(newData, callback=()=>{}){
    this.setState({
      dialogData:{
        ...newData,
        values:{
          ...newData.values,
        }
      }
    }, ()=>callback())
  }

  validateMemoCallback(index, newData){
    const newDetail = {
      ...this.state.securityDepositDetails[index],
      ...newData.values,
      update : true
    }
    this.setState({
      securityDepositDetails: [
        ...this.state.securityDepositDetails.slice(0, index),
        newDetail,
        ...this.state.securityDepositDetails.slice(index + 1 , this.state.securityDepositDetails.length),
      ]
    });
  }

  selectedSecurityDeposit() {
    if(!this.validate(this.state.dialogData.errors)){
      return;
    }
    const { 
      security_deposit_collect_date,
      security_deposit_collect_amt,
      security_deposit_collect_type,
      security_deposit_collect_memo,
    } = this.state.dialogData.values;
    const depositHistoryIndex = this.state.depositHistoryIndex
    const newData = {security_deposit_collect_date,security_deposit_collect_amt,security_deposit_collect_type,security_deposit_collect_memo}
    
    this.setState({
      ...this.state,
      securityDepositDetails : 
      depositHistoryIndex === undefined 
      ?[...this.state.securityDepositDetails, newData]
      :[...this.state.securityDepositDetails.map((depositHistory, index)=> {
        return depositHistoryIndex === index ? {...depositHistory, ...newData, update : depositHistory.id === undefined ? undefined : true } : depositHistory 
      })]
    }, () => {
      this.calcTotalAmount()
      this.toggleRegistModal();
    })
  }

  securityDepositEdit(index){
    this.setState({
      depositHistoryIndex : index,
      dialogData:{
        ...this.state.dialogData,
        values:{
          ...this.state.securityDepositDetails[index]
        },
        errors : {},
      },
      regist_modal: !this.state.regist_modal
    }, () => {
      this.calcTotalAmount()
    });
  }

  securityDepositRemove(removeIndex){
    this.props.alertModal.current.confirmCheck({messageNo:2411},()=>{
      const newDetails = this.state.securityDepositDetails.map((item, index)=>{
        if(index === removeIndex){
          item.delete = true;
        }
        return item;
      })
      this.setState({
        securityDepositDetails: newDetails
      }, () => {
        this.calcTotalAmount()
      });
    })
  }

  toggleRegistModal(reset=false) {
    if (reset) {
      this.setState({
        ...this.state,
        regist_modal: !this.state.regist_modal,
        depositHistoryIndex : undefined,
        dialogData:{
          ...this.state.dialogData,
          values:{},
          errors:{
            security_deposit_collect_date:[GetMessage(2024)],
            security_deposit_collect_amt:[GetMessage(2024)],
            security_deposit_collect_type:[GetMessage(2024)],
          }
        },
      });
    } else {
      this.setState({
        regist_modal: !this.state.regist_modal,
      })
    }
  }

  toggleSubRegistModal(){
    this.setState({
      sub_regist_modal: !this.state.sub_regist_modal
    });
  }

  regist() {
    const params = {
      securityDeposit : this.state.data.values,
      securityDepositDetails : this.state.securityDepositDetails.filter(item => !(item.id === undefined && item.delete === true)).map((detail)=>{
        return {
          ...detail,
          security_deposit_collect_user_id : GsuiteAuth.get("id"),
        }
      })
    }

    Request.put('/api/securitydeposit/detail/update', params, res => {
      this.props.pageChangeAlert.current.inactivate();
      this.toggleSubRegistModal();
      this.props.history.push("/securitydeposit");  
    });
  }

  security_deposit_details({data={},index}){
    const {
      security_deposit_collect_date,
      security_deposit_collect_amt,
      security_deposit_collect_type,
      security_deposit_collect_memo,
    } = data
    const align={
      verticalAlign: "top",
      textAlign: "left"
    }
    const ButtonWithRole = WithRole(Button, this.props.buttons, data)
    return (
      data.delete !== true && 
      <>
        <tr key={index}>
          <td  style={align}>{Format.format_date(security_deposit_collect_date)}</td>
          <td  style={align}>{Format.comma_delimited(security_deposit_collect_amt, "円")}</td>
          <td  style={align}>{FormatCode.decode("cst_security_deposit_collect_type", security_deposit_collect_type)}</td>
          {/* <td  style={align}>{security_deposit_collect_memo}</td> */}
          <td>
            <InputText 
              name="SECURITY_DEPOSIT_DETAIL__security_deposit_collect_memo"
              multiline={true}
              validateCallback={(newData) => this.validateMemoCallback(index, newData)} 
              validateType='regist'
              rootData={{values : { security_deposit_collect_memo : security_deposit_collect_memo }}}
            />
          </td>
          <td>
            <ButtonWithRole 
              button_id={"BTN_J1_02_04930"}
              type="button" 
              className="btn btn-sm" 
              data-dismiss="modal" 
              aria-label="Close" 
              disabled={this.state.data.values.security_deposit_status == 2}
              onClick={() => {this.securityDepositEdit(index)}}
            >
              編集
            </ButtonWithRole>
            <ButtonWithRole 
              button_id={"BTN_J1_02_04940"}
              type="button" 
              className="btn btn-sm" 
              data-dismiss="modal" 
              aria-label="Close" 
              disabled={this.state.data.values.security_deposit_status == 2}
              onClick={() => {this.securityDepositRemove(index)}}
            >
              削除
            </ButtonWithRole>
          </td>
        </tr>
      </>
    );
  }

  calcTotalAmount(){
    const {
      add_cost_security_deposit_amt,
      quote_cost_security_deposit_total_amt
    } = this.state.data.values
    const collectTotal = this.state.securityDepositDetails.reduce((acc, detail) => {
      // コード表の情報取得
      const typeInfo = cst_security_deposit_collect_type.find(item => item.value == detail.security_deposit_collect_type)

      // 集計対象ではない場合0とする
      const amt = typeInfo.aggregate === true ? detail.delete !== true ? detail.security_deposit_collect_amt : 0 : 0
      return acc + amt
    }, 0)

    this.setState({
      data : {
        ...this.state.data,
        values : {
          ...this.state.data.values,
          security_deposit_collect_total_amt : collectTotal,
          security_deposit_uncollect_amt : quote_cost_security_deposit_total_amt + add_cost_security_deposit_amt - collectTotal
        }
      }
    })
  }

  render() {
    const SecurityDepositDetails = this.security_deposit_details
    const ButtonWithRole = WithRole(Button, this.props.buttons, this.state.data.values)
    const user = this.state.user_list.find(user => user.id === this.state.dialogData.values.security_deposit_collect_user_id)
    return (
      <>
        <div className="content">
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h3" className="float-left">{`敷金管理　入金履歴${this.state.view?"更新":"登録"}`}</CardTitle>
              </CardHeader>
              <Col md="11"  className="detail">
                <Table>
                  <tbody>
                    <tr>
                      <th>敷金</th>
                      <th className="sub">入金額合計</th>
                      <th className="sub">残額</th>
                    </tr>
                    <tr>
                      <td>
                        {Format.comma_delimited(this.state.data.values.___CAL_security_deposit_amt,"円")}
                      </td>
                      <td>
                        {Format.comma_delimited(this.state.data.values.security_deposit_collect_total_amt,"円")}
                      </td>
                      <td>
                        {Format.comma_delimited(this.state.data.values.security_deposit_uncollect_amt,"円")}
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <Row>
                  <Col md="6">
                      <CardTitle tag="h4" className="float-left">仕入先情報</CardTitle>
                  </Col>
                </Row>
                  <Table>
                    <tbody>
                      <tr>
                          <th>見積ID</th>
                          <th>仕入先</th>
                          <th>契約終了日</th>
                          <th>入金メモ</th>
                      </tr>
                      <tr>
                        <td>{this.state.data.values.estimate_natural_id}</td>
                        <td>
                          <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_security_deposit_supplier', this.state.data.values)}} />
                        </td>
                        <td>{Format.format_date(this.state.data.values.quote_available_end_date)}</td>
                        <td>{this.state.data.values.security_deposit_memo}</td>
                      </tr>
                    </tbody>
                  </Table>
                <Row>
                  <Col md="6">
                      <CardTitle tag="h4" className="float-left sub">入金履歴</CardTitle>
                  </Col>
                  <Col md="6">
                      <ButtonWithTooltip 
                        button_id={"BTN_J1_02_04920"}
                        onclick={() => { this.toggleRegistModal(true); }} 
                        disabled={
                          this.state.data.values.security_deposit_status == 2
                          || this.state.securityDepositDetails.filter(item =>(item.delete!==true)).length >= 10}
                        class="btn-search btn-facebook float-right" 
                        id="tmp" 
                        icon="fas fa-plus"
                        label="追加" 
                        message="入金履歴を追加します。" />
                  </Col>
                </Row>
                <Table>
                    <tbody>
                      <tr>
                        <th className="sub">入金日</th>
                        <th className="sub">入金額</th>
                        <th className="sub">入金種別</th>
                        <th className="sub">入金履歴メモ</th>
                        <th className="sub">削除</th>
                      </tr>
                    {this.state.securityDepositDetails.length>0 && this.state.securityDepositDetails.map((data,index)=> {
                      return <SecurityDepositDetails data={data} index={index} key={index}/>
                    })}
                    </tbody>
                </Table>
                <Container>
                  <Row>
                    <Col md="6"></Col>
                    <Col md="2">
                      <InputCheckBox
                        label='回収済にする'
                        name='SECURITY_DEPOSIT__security_deposit_flag'
                        labelOn={false}
                        validateCallback={this.validateCallback}
                        checkedValue={1}
                        uncheckedValue={0}
                        rootData={this.state.data}
                        validateType={'search'}
                      />
                    </Col>
                    <Col md="4">
                      <InputDatetime
                        label='回収済日付'
                        name='SECURITY_DEPOSIT__security_deposit_collect_finish_date'
                        labelOn={true}
                        validateCallback={this.validateCallback}
                        rootData={this.state.data}
                        validateType={'regist'}
                        disabled={this.state.data.values.security_deposit_status == 2}
                      />
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col md="6" className="text-center">
                      <ButtonWithRole button_id={"BTN_J1_02_04950"} color="secondary" onClick={() => { this.props.history.push("/securitydeposit")  }}>一覧に戻る</ButtonWithRole>
                    </Col>
                    <Col md="6" className="text-center">
                      <ButtonWithRole
                        button_id="BTN_J1_02_04960"
                        color="secondary info"
                        onClick={() => {
                          if(this.validate(this.state.data.errors)){
                            this.toggleSubRegistModal();}
                          }
                        }
                      >
                        入金登録
                      </ButtonWithRole>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Card>
          </Col>
        </div>
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">入金履歴登録</h5>
          </div>
          <ModalBody>
            <Row className="detail">
              <Col md="12">
                <Table>
                  <tbody>
                    <tr>
                      <CustomTd label='入金日'
                          name='SECURITY_DEPOSIT_DETAIL__security_deposit_collect_date'
                          copy={false}
                          rootData={this.state.dialogData}
                          value={
                            <InputDatetime
                              validateCallback={this.validateDialogCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='入金額'
                          copy={false}
                          value={
                            <Row>
                              <Col md="8">
                                <InputNumber
                                  name='SECURITY_DEPOSIT_DETAIL__security_deposit_collect_amt'
                                  rootData={this.state.dialogData}
                                  validateCallback={this.validateDialogCallback} 
                                  validateType='regist'
                                  size={12}
                                  unit="円"
                                />
                              </Col>
                              <Col md="4">
                                <ButtonWithRole 
                                  button_id ={"BTN_J1_02_04970"}
                                  size="sm" 
                                  color="secondary" 
                                  onClick={() => {
                                    this.setState({
                                      dialogData : {
                                        ...this.state.dialogData,
                                        values : {
                                          ...this.state.dialogData.values,
                                          security_deposit_collect_amt : 
                                            this.state.depositHistoryIndex !== undefined
                                            ? this.state.securityDepositDetails[this.state.depositHistoryIndex].security_deposit_collect_amt + this.state.data.values.security_deposit_uncollect_amt
                                            : this.state.data.values.security_deposit_uncollect_amt
                                        },
                                        errors : {
                                          ...this.state.dialogData.errors,
                                          security_deposit_collect_amt : undefined
                                        }
                                      }
                                    })
                                  }}>残額全て</ButtonWithRole>
                              </Col>
                            </Row>
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='入金種別'
                        name='SECURITY_DEPOSIT_DETAIL__security_deposit_collect_type'
                        copy={false}
                        rootData={this.state.dialogData}
                        value={
                          <InputSelect
                            options={cst_security_deposit_collect_type}
                            validateCallback={this.validateDialogCallback} 
                            validateType='regist'
                            isSearchable={true}
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='入金履歴メモ'
                        name='SECURITY_DEPOSIT_DETAIL__security_deposit_collect_memo'
                        copy={false}
                        rootData={this.state.dialogData}
                        value={
                          <InputText multiline={true}
                            validateCallback={this.validateDialogCallback} 
                            validateType='regist'
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label='入金履歴登録者'
                        name='SECURITY_DEPOSIT_DETAIL__security_deposit_collect_user_id'
                        copy={false}
                        value = {user ? user.name : ""}
                      />
                    </tr>
                  </tbody>
                </Table>
            </Col>
            <Col md="12" className="text-center">
              <ButtonWithRole 
                button_id = {"BTN_J1_02_04980"}
                color="info" 
                onClick={() => {
                  this.selectedSecurityDeposit();
                }} className="float-right"
              >
                入金履歴追加
              </ButtonWithRole>
            </Col>
          </Row>
          </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.sub_regist_modal} toggle={this.toggleSubRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleSubRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">入金登録</h5>
          </div>
          <ModalBody>
            <p>入金登録をします。よろしいですか？</p>
            {this.state.data.values.accounts_receivable_collection_flag === 1 
            && this.state.data.values.security_deposit_uncollect_amt !== 0 &&
            <div style={{color:"red"}}>{GetMessage(2464)}</div>}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleSubRegistModal}>
              いいえ
            </Button>
            <Button color="info" onClick={()=>{this.regist()}}>
              はい
            </Button>
          </ModalFooter>
        </Modal> 
      </>
    );
  }
}

export default Regist;
